'use client';
import { SessionProvider } from 'next-auth/react';
import { LangProvider } from '@/components/i18n/LangProvider';
import type { Locale } from '@/lib/i18n/config';
import type { Surcharges } from '@/lib/i18n/t';

export function Providers({ children, lang, surcharges }: { children: React.ReactNode; lang: Locale; surcharges?: Surcharges }) {
  return (
    <SessionProvider>
      <LangProvider lang={lang} surcharges={surcharges}>{children}</LangProvider>
    </SessionProvider>
  );
}
